const serviceLineRoutes = [
  {
    path: "serviceline",
    name: "Service Line",
    redirect: {
      name: "Service Line List"
    },
    component: () =>
      import(/* webpackChunkName: "service line" */ "../../views/serviceLine/ServiceLine.vue"),
    children: [
      {
        path: "list",
        name: "Service Line List",
        component: () =>
          import(/* webpackChunkName: "service line" */ "../../views/serviceLine/ServiceLineList.vue")
      },
      {
        path: "details/:id",
        name: "Service Line Detail",
        component: () =>
          import(/* webpackChunkName: "service line" */ "../../views/serviceLine/ServiceLineDetail.vue")
      }
    ]
  }
];

export default serviceLineRoutes;
